import { createContext } from 'react';

// Criamos o contexto. O valor 'null' é o valor padrão.
export const DataContext = createContext(null);